export default function Intro() {
  return (
    <section className="intro">
      <h1>
        <span className="me">Hassan</span>
        <span className="me">Warwick</span>
        <i className="fi fi-bs-arrow-small-right"></i>
      </h1>
      <div className="intro-text">
        <span className="span">/This is me</span>
        <h3>Experience developer and designer from Lagos, Nigeria.</h3>
        <p>
          Passionate web developer crafting immersive online experiences with a
          focus on user-centric design and seamless functionality.
        </p>
        <span className="more">
          Scroll for more<i className="fi fi-bs-arrow-small-down"></i>
        </span>
      </div>
      <div className="develop">Experince Developer</div>
      <div className="design">Designer</div>
    </section>
  );
}
